import { forwardRef, PropsWithChildren } from "react";
import MuiBox, { BoxProps as MuiBoxProps } from "@mui/material/Box";

export type FlexProps = MuiBoxProps;

const FlexComponent = forwardRef<HTMLDivElement, PropsWithChildren<FlexProps>>((props, ref) => {
  return <MuiBox display="flex" ref={ref} {...props} />;
});
FlexComponent.displayName = "Flex";

const Flex = FlexComponent as typeof MuiBox;
export default Flex;
